import React from 'react'
import { t } from '@lingui/macro'
import { useHistory } from 'react-router-dom'
import {
  NATIVE_PUBLIC_ROUTES,
  nativePublicPathGenerator
} from 'routes/native/PublicRoutes'
import { useCompanyName } from 'pages/native/onBoarding/context/OnBoardingContext'
import {
  Button,
  Header,
  NextIcon,
  SectionHeader
} from 'pages/native/onBoarding/components'
import HighResHomeFeedMockUp from '../WelcomePage/assets/images/HighResHomeFeedMockUp.png'
import LowResHomeFeedMockUp from '../WelcomePage/assets/images/LowResHomeFeedMockUp.jpeg'
import { LazyImageLoader } from './components/LazyImageLoader/LazyImageLoader'

import styles from './WelcomePage.module.scss'

export const WelcomePage = () => {
  const history = useHistory()
  const { value: company } = useCompanyName()

  return (
    <div className={styles.PageContainer}>
      <Header back={() => history.goBack()} steps={4} currentStep={1} />
      <div className={styles.ContentContainer}>
        <SectionHeader
          title={t`All in one place.`}
          body={t`Get latest live stream, breaking news, and more from the teams you care about - all in your personalized home feed.`}
          textAlign="left"
        />
        <LazyImageLoader
          lowSrc={LowResHomeFeedMockUp}
          highSrc={HighResHomeFeedMockUp}
          alt="Home feed illustration"
        />
        <Button
          label={t`Next`}
          icon={<NextIcon />}
          iconPosition="right"
          variant="filled"
          theme="primary"
          onClick={() =>
            history.push(
              nativePublicPathGenerator(
                NATIVE_PUBLIC_ROUTES.ON_BOARDING.FOLLOW,
                company
              )
            )
          }
        />
      </div>
    </div>
  )
}
